import { Navigate } from 'react-router-dom';

import { useUserDataStore } from '../../newStore/userDataStore';
import { paths } from '../../utils/navigation';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermissions?: string[];
  allowSuperAdmin?: boolean;
  allowAdmin?: boolean;
  allowSupport?: boolean;
  customMandatoryCondition?: () => boolean;
  customAccessCondition?: () => boolean;
  redirectTo?: string;
}

export function ProtectedRoute({
  children,
  allowSuperAdmin = true,
  allowAdmin = true,
  allowSupport = true,
  customMandatoryCondition,
  customAccessCondition,
  redirectTo = paths.home.index,
}: ProtectedRouteProps) {
  const currentUser = useUserDataStore((state) => state.currentUser);

  // Check role-based access
  const hasRoleAccess =
    (allowSuperAdmin && currentUser?.is_superadmin) ||
    (allowAdmin && currentUser?.is_admin) ||
    (allowSupport && currentUser?.is_support);

  // Check custom condition, must comply with it to access the page
  const passesCustomMandatoryCondition = customMandatoryCondition
    ? customMandatoryCondition()
    : true;

  // gives extra access it it comply with it
  const passesCustomAccessCondition = customAccessCondition ? customAccessCondition() : true;

  // If user doesn't have access, redirect
  if (!passesCustomMandatoryCondition) {
    return (
      <Navigate
        to={redirectTo}
        replace
      />
    );
  }

  if (!hasRoleAccess && !passesCustomAccessCondition) {
    return (
      <Navigate
        to={redirectTo}
        replace
      />
    );
  }

  return <>{children}</>;
}
